import { memo } from 'react';

import Sign from '../Sign';
import styles from './PhotoCard.module.css';

import type { MediaData } from '@Pages/PageWikiArticle/typings';
import type { FC, HTMLAttributes } from 'react';

export interface PhotoCardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  media: MediaData;
}

const PhotoCard: FC<PhotoCardProps> = (props) => {
  const { media, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className={styles.imageWrapper}>
        <img className={styles.media} src={media.img} alt='' />
      </div>

      <Sign className={styles.sign}>{media.sign}</Sign>
    </div>
  );
};

export default memo(PhotoCard);
